import { useState } from "react";
import styled from "styled-components";
import logo from "../assets/images/xl_logo.png";
import toast from "../assets/images/toast-logo_color.png"

const HeaderLogoContainer = styled.div`
    margin: 10px 20px;
    min-width: 50%;
    display: flex;
    flex-direction: row;
    align-items: center;
`;

const XlIcon = () => {
    const ImageWrapper = styled.a`
        width: 50px;
        height: 50px;
    `;

    const ImageStyle = styled.img`
        width: 100%;
    `;

    return (
        <ImageWrapper href="/">
            <ImageStyle src={logo} alt="xiao loong" />
        </ImageWrapper>
    );
};

const DoorDashOrderButton = () => {
    const DoorDashBtnWrapper = styled.a`
        text-decoration: none;
        height: 50px;
        margin-left: 20px;
    `;

    const DoorDashBtn = styled.div`
        position: relative;
        background-size: auto 100%;
        background-position: center;
        width: 180px;
        height: 50px;
        border-radius: 3px;
        background-image: url(https://cdn.doordash.com/media/button/button_red_l.svg);
        color: transparent;
    `;

    return (
        <DoorDashBtnWrapper
            href="https://order.online/store/xiao-loong-restaurant-297380?btn=main"
            target="_blank"
            onClick={() => {
                window.gtag("event", "click_doordash", "click_doordash", {
                    btn: "main"
                });
            }}
            alt="Order Food Delivery with DoorDash"
            title="Order Food Delivery with DoorDash"
        >
            <DoorDashBtn>Order Food Delivery with DoorDash</DoorDashBtn>
        </DoorDashBtnWrapper>
    );
};

const ToastOrderBtn = () => {
    const OrderBtnWrapper = styled.a`
        display: flex;
        align-items: center;
        text-decoration: none;
        height: 50px;
        margin-left: 20px;
        border: none;
    `;

    const OrderText = styled.div`
        display: inline-block;
        font-size: 28px;
        font-weight: 800;

        @media (max-width: 768px) {
            font-size: 20px;
        }
    `;

    const OrderImg = styled.div`
        display: inline-block;
        position: relative;
        background-size: 80% auto;
        background-repeat: no-repeat;
        background-position: center;
        width: 160px;
        height: 50px;
        border: none;
        background-image: url(${toast});

        @media (max-width: 768px) {
            width: 140px;
        }
    `;

    return (
        <OrderBtnWrapper href="https://www.toasttab.com/xiao-loong-restaurant-250-west-portal-avenue" target="_blank">
            <OrderText>Order Online:</OrderText>
            <OrderImg />
        </OrderBtnWrapper>
    );
};

const HomeHeader = props => {
    const HeaderWrapper = styled.div`
        width: 100vw;
        font-family: "Sue Ellen Francisco", cursive;
    `;
    const { handleHamburgerIconClick, handleViewChange } = props;
    const [showMobileNav, setShowMobileNav] = useState(false);
    const changeMobileView = (view) => {
        setShowMobileNav(false);
        handleViewChange(view);
    }
    return (
        <HeaderWrapper>
            <div className="header">
                <HeaderLogoContainer>
                    <XlIcon />
                    <ToastOrderBtn />
                </HeaderLogoContainer>
                <div className="header-items">
                    <div
                        id="lunch-menu"
                        onClick={() => handleViewChange("lunch")}
                    >
                        Lunch Menu
                    </div>
                    <a
                        id="dinner-menu"
                        href="https://www.toasttab.com/xiao-loong-restaurant-250-west-portal-avenue"
                        target="_blank"
                    >
                        Dinner Menu
                    </a>
                    <div
                        id="contact"
                        onClick={() => handleViewChange("contact")}
                    >
                        Hours &amp; Location
                    </div>
                </div>
                <div
                    className="header-items-mobile"
                    onClick={() => setShowMobileNav(!showMobileNav)}
                >
                    <i className="fa fa-bars" aria-hidden="true"></i>
                </div>
            </div>
            {showMobileNav && (
                <div className="header-items-mobile-nav">
                    <div onClick={() => changeMobileView("lunch")}>Lunch Menu</div>
                    <a href="https://www.toasttab.com/xiao-loong-restaurant-250-west-portal-avenue" target="_blank">Dinner Menu</a>
                    <div onClick={() => changeMobileView("contact")}>Hours &amp; Location</div>
                    <div onClick={() => changeMobileView("about")}>About Us</div>
                </div>
            )}
        </HeaderWrapper>
    );
};

export default HomeHeader;
